import { render, staticRenderFns } from "./Findthenumber.vue?vue&type=template&id=34c9d766&"
import script from "./Findthenumber.vue?vue&type=script&lang=js&"
export * from "./Findthenumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports